import { z } from 'zod';
import * as component from './freeform-component.schema';


export const freeformBodyHeaderSchema = z.object({
	type: z.string(),
    heading: z.string(),
});

export const freeformBodyColumnSchema = z.object({
	columnCount: z.number(),
	controls: z.array(z.union([
		component.freeformZenDeskArticleSchema,
		component.freeformZenDeskCategoriesSchema,
		component.freeformZenDeskSectionsByCategorySchema,
		component.freeformZenDeskSearchResultsSchema,
		component.relatedArticlesSchema,
		component.richtextSchema,
		component.accordionSchema,
		component.embedSchema,
	])),
});

export const freeformBodyRowSchema = z.object({
	columns: z.array(freeformBodyColumnSchema),
	columnCount: z.number(),
	tweakColumnsForMobile: z.boolean(),
	addDivider: z.boolean(),
});

export const freeformBodySchema = z.object({
	main: z.object({
		header: freeformBodyHeaderSchema,
		theme: z.string(),
        template: z.string(),
		rows: z.array(freeformBodyRowSchema),
	}),
});

